<template>
  <div class="manage">
    <ClearPhoneNoDialog :type-fix="clearPhoneNumDialog.typeForFixButton" :show="clearPhoneNumDialog.isShow" :pageName="clearPhoneNumDialog.pageName" @dialogClose="clearDialogClose"></ClearPhoneNoDialog>

    <el-drawer :visible.sync="drawer" :before-close="handleClose">
      <el-form :model="form" ref="form" :rules="rules" class="edit-form">
        <div class="main-content">
          <el-form-item v-if="this.formType == 'add' || this.formType == 'update'"
                        label="所属部门" required>
            <el-select ref="selectOption" v-model="optionSelectValue.label" placeholder="选择员工所在部门" clearable>
              <el-option :value="optionSelect" style="overflow: auto; height: 100%">
                <el-tree :data="treeData" @node-click="(data, node, item) => handleTreeClick(data, node, item)"/>
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item v-for="(item, index) in formLabel" :key="index" :prop="item.prop" :label="item.label + ':'">
            <el-input :disabled="formType == 'show' ? true : false" :placeholder="'请输入' + item.label"
                      v-model="form[item.prop]"></el-input>
          </el-form-item>

        </div>

        <div class="footer-content">
          <el-form-item>
            <el-button size="mini" type="primary" @click="onSubmit">确认</el-button>
            <el-button size="mini" @click="onCancel">取消</el-button>
          </el-form-item>
        </div>
      </el-form>
    </el-drawer>

    <div class="header">
      <div class="left">
        <el-row>
          <h3 style="color: green; margin-top: 0">全员信息管理</h3>
        </el-row>

        <el-row class="left-content">
          <el-input prefix-icon="el-icon-search" placeholder="搜索员工姓名/手机号" size="small" clearable
                    style="width: 400px; cursor: pointer" v-model="searchContent"/>

          <el-button type="info" plain size="mini" style="margin-left: 5px" @click="search()">搜索</el-button>
          <el-button type="danger" plain size="mini" style="margin-left: 30px" @click="cleartextShow('成员管理')">明文查看
          </el-button>
          <el-button type="success" plain size="mini" @click="exportEmployees">导出成员</el-button>
        </el-row>
      </div>

      <div class="right">
        <el-button type="primary" size="mini" @click="addEmployee()" :disabled="!hasCommitPermission">添加成员
        </el-button>
        <el-button type="danger" size="mini" @click="deleteSelected()" :disabled="!hasCommitPermission">删除选中
        </el-button>
      </div>
    </div>

    <div class="content">
      <el-table :data="tableData" border @selection-change="handleSelectionChange" style="width: 100%">
        <el-table-column type="selection" width="55">
        </el-table-column>

        <el-table-column v-for="(item, index) in formLabel" :key="index" :prop="item.prop" :label="item.label" :width="item.width">
          <template slot-scope="scope">
            <template v-if="item.type === 1">
              <template v-if="phoneNumShow">{{ scope.row[item.prop] }}</template>
              <template v-else> {{ scope.row[item.prop] | phNoFilter }}</template>
            </template>
            <template v-else>{{ scope.row[item.prop] }}</template>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="220px">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="tableShow(scope.row)">查 看</el-button>
            <el-button type="success" size="mini" @click="tableUpdate(scope.row)" :disabled="!hasCommitPermission">修
              改
            </el-button>
            <el-button type="warning" size="mini" @click="tableDelete(scope.row)" :disabled="!hasCommitPermission">删
              除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pager">
        <el-pagination layout="sizes, prev, pager, next, jumper" :total="totalCount" :page-sizes="pageSizes"
                       :page-size.sync="curPageSize" :pager-count="5"
                       :current-page.sync="curPageIndex" @size-change="handleSizeChange"
                       @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {addOption} from "@/api/log-api";
import {mapState} from 'vuex'
import {mixin_clearPhoneNumShow, mixin_page_table} from '../../utils/mixin'
import {manage_mixin_table} from './manage-mixin'
import {addEmployee, deleteEmployee, deleteEmployeeByBatch, getEmployeeByPage, updateEmployee} from '../../api/organize-api'
import {getAllRoleList} from "@/api/role-api";
import ClearPhoneNoDialog from "@/components/ClearPhoneNoDialog.vue";
import ExcelJS from "exceljs";

let self = null

export default {
  components: {ClearPhoneNoDialog},
  mixins: [mixin_page_table, manage_mixin_table, mixin_clearPhoneNumShow],

  mounted() {
    this.loadTreeData()
    this.refreshTableData()
    self = this

    getAllRoleList().then(({data}) => {
      if (data.code === 200) {
        this.roleList = data.data
        data.data.forEach((item) => {
          this.roleSelectData.push({value: item.id, label: item.name,})
        })
      } else {
        this.showServerErrMsg(data.code);
      }
    }).catch(() => {
      this.showNetErrMsg();
    })
  },

  data() {
    return {
      rules: {
        name: [
          {required: true, message: '请输入员工姓名', trigger: 'change'},
          // { min: 3, max: 20, message: '长度在 3 到 20 个字符', trigger: 'blur' }
        ],
        tel: [
          {required: true, message: '请输入员工手机', trigger: 'change'},
          // { min: 3, max: 20, message: '长度在 3 到 20 个字符', trigger: 'blur' }
        ],
        // role: [
        //   {required: true, message: '请选择员工角色', trigger: 'change'},
        // ],
        // loginName: [
        //   {required: true, message: '请输入员工账号', trigger: 'change'},
        // ],
        // defaultPassword: [
        //   {required: true, message: '请输入初始密码', trigger: 'change'},
        // ],

      },

      searchContent: "",
      phoneTextShowFull: false,

      tableData: [],
      tableChecked: [],
      tableSelectRow: {},

      optionSelect: [],
      optionSelectValue: {
        id: -2,//初始化，没有其它意义
        label: ""
      },
      treeSelectValue: "",
      treeData: [],

      drawer: false,
      formType: "",
      form: {},
      formLabel: [
        {prop: 'name', label: '员工姓名', width: ""},
        {prop: 'tel', label: '手机号码', type: 1, width: "120px"},
        // {prop: 'loginName', label: '登陆账号', width: ""},
        {prop: 'title', label: '员工职位', width: ""},
        {prop: 'workId', label: '员工工号', width: ""},
        {prop: 'email', label: '员工邮箱', width: ""},
        {prop: 'age', label: '员工年龄', width: "80px"},
        {prop: 'departmentName', label: '所属部门', width: ""},
      ],


      roleSelectData: [
        {value: "MANAGE", label: "系统管理员"},
        {value: "VIEW", label: "系统查看员"},
        {value: "GUARD", label: "门岗助手"},
        {value: "STAFF", label: "员工邀约"},
      ],
      roleList: [],

    };
  },

  computed: {
    ...mapState(['loginInfo']),

    hasCommitPermission() {
      switch (this.$store.state.roleType) {
        case "ADMIN":
        case "MANAGE":
          return true
        case "VIEW":
        case "GUARD":
        case "STAFF":
          return false
        case "COMMON":
          return this.$store.state.myPermissions.includes("ROLE_MANAGE_MODIFY")
        default:
          return false
      }
    }

  },
  methods: {
    search() {
      this.curPageIndex = 1
      this.refreshTableData()
    },

    handleClose(done) {
      done()

      let result = this.formLabel.find(item => {
        return item.prop === 'departmentName'
      })

      if (typeof (result) == 'undefined') {
        this.formLabel.push({
          prop: 'departmentName',
          label: '所属部门'
        })
      }
    },

    handleTreeClick(data, node, item) {
      console.log("handleTreeClick", data, node, item)

      this.treeSelectValue = data

      this.optionSelectValue = {
        "id": this.treeSelectValue.id,
        "label": this.treeSelectValue.label
      }
      this.$refs.selectOption.blur();
    },

    onSubmit() {
      if (this.treeSelectValue.id <= 0) {
        this.$message.error('请选择员工所在部门');
        return
      }
      this.$refs["form"].validate((valid) => {
        if (valid) {
          if (this.formType === "update") {
            this.onSubmitUpdate()
          } else if (this.formType === "add") {
            this.onSubmitAdd()
          } else {
            this.drawer = false
          }
        } else {
          console.log('validate error, error submit!!');
        }
      });
    },

    onSubmitUpdate() {

      let roleType = this.form.role
      let roleValue = null
      if (this.form.role === 'STAFF' || this.form.role === 'GUARD' || this.form.role === 'VIEW' || this.form.role === 'MANAGE') {
        roleType = this.form.role
        roleValue = null
      } else {
        roleType = 'COMMON'
        roleValue = this.form.role
      }
      let postData = {
        id: this.tableSelectRow.id,
        name: this.form.name,
        tel: this.form.tel,
        departmentId: this.treeSelectValue.id,
        workId: this.form.workId,
        age: this.form.age,
        email: this.form.email,
        title: this.form.title,
        roleType: roleType,
        roleValue: roleValue,
        loginName: this.form.loginName,
      }
      console.log("updateEmployee postData =>", postData)
      updateEmployee(postData).then(({data}) => {
        console.log("updateEmployee data =>", data.data)

        if (data.code === 200) {
          this.formLabel.push({
            prop: 'departmentName',
            label: '所属部门'
          })

          let row = this.tableSelectRow

          for (var key in data.data) {
            // console.log("key = ", key)
            row[key] = data.data[key]
          }

          this.form = {}
          this.drawer = false

          this.$message.success('修改成功');
        } else if (data.code === 700) {
          let employee = data.data

          if (employee.parentId != null) {
            this.$message.error("'" + employee.name + "'" + ",手机号:" + "'" + employee.tel + "'" + "已经存在");
          } else {
            this.$message.error("'" + employee.departmentName + "'" + "部门，已经存在" + "'" + employee.name + "'" + ",手机号:" + "'" + employee.tel + "'");
          }
        } else {
          this.showServerErrMsg(data.code);
        }
      }).catch((error) => {
        this.showNetErrMsg();
        console.error("error =>", error)
      })
    },

    onSubmitAdd() {

      let roleType = this.form.role
      let roleValue = null
      if (!["MANAGE", "VIEW", "GUARD", "STAFF"].includes(this.form.role)) {
        roleType = 'COMMON'
        roleValue = this.form.role
      }

      let postData = {
        name: this.form.name,
        tel: this.form.tel,
        departmentId: this.treeSelectValue.id,
        workId: this.form.workId,
        age: this.form.age,
        title: this.form.title,
        email: this.form.email,
        defaultPassword: this.form.defaultPassword,
        loginPassword: this.form.defaultPassword,
        roleType: roleType,
        roleValue: roleValue,
        loginName: this.form.loginName,
      }


      console.log("addEmployee postData =>", postData)
      addEmployee(postData).then(({data}) => {
        console.log("employee data =>", data)

        if (data.code === 200) {
          this.formLabel.push({
            prop: 'departmentName',
            label: '所属部门'
          })


          this.drawer = false

          this.form = {}

          this.refreshTableData()

          this.$message.success('添加成功');
        } else if (data.code == 700) {
          let employee = data.data

          if (employee.parentId != null) {

            this.$message.error(`'${employee.name}', 手机号: '${employee.tel}' 已经存在`);
          } else {
            this.$message.error(`'${employee.departmentName}'部门，已经存在'${employee.name}'，手机号：'${employee.tel}'`)
          }
        } else {
          this.showServerErrMsg(data.code);
        }
      }).catch((error) => {
        console.log("error =>", error)
      })
    },

    onCancel() {
      this.drawer = false
    },


    requestLog(logType) {
      let accountId = this.loginInfo.id
      let data = {"accountId": accountId, "type": logType, "request": "", "response": ""}
      addOption(data).then(({data}) => {
        console.log("data =>", data)
      }).catch(err => {
        console.log(" checkVerCode =>", err)
      })
    },

    async exportEmployees() {
      console.log("exportEmployees start")
      console.log(this.tableData)
      let data = []

      let header = []
      this.formLabel.forEach(({label}) => {
        header.push(label)
      })
      data.push(header)
      const columnsSize = header.length
      this.tableData.forEach(({name, workId, departmentName, age, tel, title, loginName, email}) => {
        let line = []
        // 与 formLabel 顺序保持一样
        // line.push(name, tel, loginName, title, workId, email, age, departmentName)
        line.push(name, tel, title, workId, email, age, departmentName)
        data.push(line)
      })
      const workbook = new ExcelJS.Workbook()
      const sheet = workbook.addWorksheet('Sheet1');
      sheet.addRows(data);
      const firstRow = sheet.getRow(1);
      firstRow.eachCell((cell, colNumber) => {
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: {argb: 'FFD9D9D9'},
          bgColor: {argb: 'FFD9D9D9'}
        };
        cell.font = {
          size: 12,
          bold: true
        };
      });
      firstRow.height = 20;
      for (let i = 0; i < columnsSize; i++) {
        sheet.getColumn(i + 1).width = 20;
      }


      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
      const fileName = '员工信息.xlsx';
      let link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = fileName;

      link.click();
      URL.revokeObjectURL(link.href);
      this.requestLog("员工下载")
    },

    addEmployee() {
      this.formLabel = this.formLabel.filter(item => item.prop != 'departmentName')

      this.treeSelectValue = ""
      this.optionSelectValue = {
        id: -2,
        label: ""
      }

      this.formType = "add"
      this.form = {}
      this.drawer = true
    },

    deleteSelected() {
      let delEmployeeBatch = []

      this.tableChecked.forEach((item) => {
        delEmployeeBatch.push(item.id)
      })

      deleteEmployeeByBatch(delEmployeeBatch).then(({data}) => {
        // console.log("data => ", data)
        // console.log("treeSelectValue => ", this.treeSelectValue)

        if (data.code === 200) {
          this.refreshTableData()

          this.$message.success('删除成功');
        } else {
          this.showServerErrMsg(data.code);
        }
      }).catch(() => {
        // console.log("error => ", error)
        this.showNetErrMsg();
      })
    },

    addBatchesComployee() {
      this.$message.error('功能未开通');
    },

    tableShow(row) {
      let result = this.formLabel.find(item => {
        return item.prop == 'departmentName'
      })

      // console.log("result =>", result)

      if (typeof (result) == 'undefined') {
        this.formLabel.push({
          prop: 'departmentName',
          label: '所属部门'
        })
      }

      this.formType = "show"
      this.form = {...row}
      if (row.roleType === 'COMMON') {
        this.form.role = row.roleValue
      } else {
        this.form.role = row.roleType
      }
      if (!this.phoneNumShow) {
        this.form.tel = this.toFixShowTel(this.form.tel)
      }
      this.drawer = true
    },

    tableUpdate(row) {
      if (!this.checkFixButtonPass("员工管理")) {
        return
      }
      console.log("tableUpdate row =>", row)
      this.formLabel = this.formLabel.filter(item => item.prop !== 'departmentName')

      this.treeSelectValue = ""
      this.optionSelectValue = {
        "id": row.departmentId,
        "label": row.departmentName
      }
      this.tableSelectRow = row
      this.formType = "update"

      let role = row.roleType
      if (row.roleType === 'COMMON') {
        role = row.roleValue
      }
      this.form = {
        name: row.name,
        tel: row.tel,
        workId: row.workId,
        age: row.age,
        title: row.title,
        loginName: row.loginName,
        email: row.email,
        role: role
      }

      this.drawer = true
    },

    tableDelete(row) {
      deleteEmployee(row.id).then(({data}) => {
        if (data.code === 200) {
          this.refreshTableData()
          this.$message.success('删除成功');
        }
      }).catch((error) => {
        console.log("error => ", error)
      })
    },

    handleSelectionChange(val) {
      this.tableChecked = val
    },

    refreshTableData() {
      let pageNum = this.curPageIndex
      let pageSize = this.curPageSize
      let searchName = this.searchContent
      getEmployeeByPage(pageNum, pageSize, searchName).then(({data}) => {
        if (data.code === 200) {
          this.tableData = data.data.data
          this.totalCount = data.data.totals
        }
      }).catch(err => {
        console.log("getEmployeeByPage =>", err)
      })
    },

    onAutoPassword() {
      console.log("onAutoPassword")
      let password = Math.random().toString(36).substr(2, 6)
      this.$set(this.form, 'defaultPassword', password)
    },
  },

  filters: {
    tableDateFilter(value, prop) {
      if (prop === "tel" && !self.phoneTextShowFull) {
        if (value == null || value.length < 11) {
          return value
        }
        return value.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
      } else {
        return value
      }
    },
  }
}

</script>

<style lang="less" scoped>
.dialog-main {
  .dialog-notify {
    font-size: 12px;
    margin-top: 8px;
    margin-bottom: 8px;
  }
}

.manage {

  .edit-form {
    display: flex;
    flex-direction: column;
    text-align: center;
    height: 100%;

    .header-content {
      margin-bottom: 20px;
    }

    .main-content {
      flex: 1 0 auto;

      .el-form-item {
        display: flex;
        justify-content: flex-start;

        /deep/ .el-form-item__label {
          width: 100px;
        }

        /deep/ .el-input {
          width: calc(20vw);
        }
      }
    }

    .footer-content {
      text-align: center;
      flex: 0 0 auto;
    }
  }

  .header {
    display: flex;
    justify-content: space-between;

    .left-content {

      margin: 0 0 20px 0; //上 右 下 左
    }

    .right {
      margin: 60px 20px 0 0; //上 右 下 左
    }
  }

}

</style>
